import { render } from "./ProjectOverview.vue?vue&type=template&id=30b29abc&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"

import "./ProjectOverview.vue?vue&type=style&index=0&id=30b29abc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b29abc"]])

export default __exports__